import { CampaignType } from '@round/api';
import capitalize from 'lodash/capitalize';
import React from 'react';
import styles from './InfluencerBarStat.module.css';
import cn from 'classnames';

type InfluencerPlatformStatProps = {
    Icon: (() => JSX.Element) | React.FC<React.SVGProps<SVGSVGElement>>;
    campaignType: CampaignType;
    followers: string;
    cost: string;
    onIconClick?: () => void;
};

const InfluencerBarStat = ({ Icon, campaignType, followers, cost, onIconClick }: InfluencerPlatformStatProps) => {
    return (
        <div className={styles.platformStat}>
            <div className={cn(styles.platformIconContainer, { [styles.linkLive]: onIconClick })} onClick={onIconClick}>
                <Icon className={styles.platformIcon} />
            </div>
            <div className={styles.barStat}>
                <div className={styles.statValue}>{followers}</div>
                <div className={styles.statSubValue}>Followers</div>
            </div>
            <div className={styles.barStat}>
                <div className={styles.statValue}>{cost}</div>
                <div className={styles.statSubValue}>{`${capitalize(campaignType)} promotion`}</div>
            </div>
        </div>
    );
};

export default InfluencerBarStat;
